import { lazy } from 'react';

// project import
import Loadable from 'components/Loadable';
import MainLayout from 'layout/MainLayout';
import { ProtectedRoute } from '../components/ProtectedRoute';

// render - usage
const UsagePage = Loadable(lazy(() => import('pages/usage')));

// render - api keys
const ApiKeysPage = Loadable(lazy(() => import('pages/api-keys')));

// render - members
const MembersPage = Loadable(lazy(() => import('pages/members')));

// render - pricings
const PricingsPage = Loadable(lazy(() => import('pages/pricings')));

// render - pricings
const ClientsPage = Loadable(lazy(() => import('pages/clients')));

// render - pricings
const EndpointsPage = Loadable(lazy(() => import('pages/endpoints')));

// render - pricings
const DigitalTwinsPage = Loadable(lazy(() => import('pages/digital-twins')));

// render - change password
const ChangePasswordPage = Loadable(lazy(() => import('pages/change-password')));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: '/',
  element: (
    <ProtectedRoute>
      <MainLayout />
    </ProtectedRoute>
  ),
  children: [
    {
      path: '/',
      element: <UsagePage />
    },
    {
      path: 'usage',
      element: <UsagePage />
    },
    {
      path: 'api-keys',
      element: <ApiKeysPage />
    },
    {
      path: 'members',
      element: <MembersPage />
    },
    {
      path: 'pricings',
      element: <PricingsPage />
    },
    {
      path: 'clients',
      element: <ClientsPage />
    },
    {
      path: 'endpoints',
      element: <EndpointsPage />
    },
    {
      path: 'digital-twins',
      element: <DigitalTwinsPage />
    },
    {
      path: 'change-password',
      element: <ChangePasswordPage />
    }
  ]
};

export default MainRoutes;
